module.exports = __webpack_public_path__ + "static/dev-0494450d6b573e38600c025634a7d75e.jpg";